export const FETCH_CATEGORIES_REQUEST = "FETCH_CATEGORIES_REQUEST";
export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";
export const FETCH_CATEGORIES_ERROR = "FETCH_CATEGORIES_ERROR";

export const UPDATE_SUBCATEGORIES = "UPDATE_SUBCATEGORIES";
export const TOGGLE_CATEGORIES = "TOGGLE_CATEGORIES";